import blackPoint from './black-point.svg';
import grayPoint from './gray-point.svg';
import client from './client.svg';

const images = { blackPoint, grayPoint, client };

export default images;
